export default __webpack_public_path__ + "static/simple-histogram-e8c61ae623cf5a49f0f04fcc4407bbad.png";